module.exports = __webpack_public_path__ + "static/media/insta-hover.9a06b87d.svg";